"use strict";

exports.__esModule = true;
exports.convertLiquidToStaking = convertLiquidToStaking;
exports.convertStakingToLiquid = convertStakingToLiquid;
exports.getExchangeRate = getExchangeRate;
var _sdkCore = require("@acala-network/sdk-core");
function getExchangeRate(totalStaking, totalLiquid, defaultExchangeRate) {
  if (defaultExchangeRate === void 0) {
    defaultExchangeRate = new _sdkCore.FixedPointNumber(0.1, 18);
  }
  if (totalStaking.isZero()) return defaultExchangeRate;
  try {
    return _sdkCore.FixedPointNumber.fromRational(totalStaking, totalLiquid);
  } catch (e) {
    return defaultExchangeRate;
  }
}
function convertLiquidToStaking(exchangeRate, liquidAmount) {
  return exchangeRate.mul(liquidAmount);
}
function convertStakingToLiquid(exchangeRate, stakingAmount) {
  return stakingAmount.div(exchangeRate);
}